import React from "react";
import { Link } from "react-router-dom";

function BlogCard({
  image,
  title,
  category,
  date,
  author,
  className = "",
  link = "#",
}) {
  return (
    <Link to={link}>
      <article
        className={`group rounded-lg bg-white/80 dark:bg-white/5 backdrop-blur-xl shadow-sm overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${className}`}
      >
        <div className="h-52 overflow-hidden bg-gray-100">
          <img
            src={image || "/placeholder.jpg"}
            alt={title || "Blog image"}
            loading="lazy"
            className="h-full w-full object-cover transition duration-500 group-hover:scale-105 "
          />
        </div>

        <div className="p-3">
          {category && (
            <span className="inline-block rounded bg-orange-100 dark:bg-orange-500/10 px-2 py-1 text-[10px] font-medium text-orange-600">
              {category}
            </span>
          )}

          <h3 className="mt-2 line-clamp-2 text-sm font-semibold text-gray-900 dark:text-white">
            {title}
          </h3>

          <div className="mt-3 flex items-center justify-between text-[11px] text-gray-500 dark:text-gray-400">
            <span>{date}</span>
            <span>{author}</span>
          </div>
        </div>
      </article>
    </Link>
  );
}

export default BlogCard;
